exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-deals {\n    margin: 50px auto;\n    width: 50%;\n    padding: 10px;\n    border: 1px solid #ddd;\n}\n\n.add-deals-header {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.deal-color {\n    display: flex;\n    margin: 15px 5px;\n    align-items: center;\n}\n\n.deal-color input[type=\"radio\"] {\n    height: 20px;\n}\n", ""]);

// exports
